__turbopack_context__.v({
  "drawerOverlay": "XvtVNq_drawerOverlay",
  "focusArea": "XvtVNq_focusArea",
  "sideNavBlock": "XvtVNq_sideNavBlock",
  "sideNavBlockFull": "XvtVNq_sideNavBlockFull",
  "sideNavBlockPositionBottom": "XvtVNq_sideNavBlockPositionBottom",
  "sideNavBlockPositionLeft": "XvtVNq_sideNavBlockPositionLeft",
  "sideNavBlockPositionRight": "XvtVNq_sideNavBlockPositionRight",
  "sideNavBlockPositionTop": "XvtVNq_sideNavBlockPositionTop",
});
